(() => {
  const root = () => window.Shopify?.routes?.root || '/';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:window.Shopify?.currency?.active || 'USD'}).format(cents / 100);
  const manifests = new Map();
  const requests = new Map();
  async function productData(handle) {
    if (requests.has(handle) && Date.now()-requests.get(handle).time>30000) requests.delete(handle);
    if (!requests.has(handle)) requests.set(handle, {time:Date.now(),promise:fetch(root()+'products/'+encodeURIComponent(handle)+'.js').then(r=>{if(!r.ok) throw Error('Availability could not be checked.'); return r.json();}).catch(e=>{requests.delete(handle); throw e;})});
    return requests.get(handle).promise;
  }
  function collapse(cards, groups) {
    const lookup = new Map(groups.flatMap(g=>g.products.map(p=>[p.id,g])));
    const present = new Set(cards.map(c=>c.dataset.productId));
    const seen = new Set();
    return cards.flatMap(card=>{
      const group=lookup.get(card.dataset.productId);
      if(!group) return [{card}];
      if(seen.has(group.key)) return [];
      seen.add(group.key);
      return [{card,group,products:group.products.filter(p=>present.has(p.id))}];
    });
  }
  class CrateProductGroup extends HTMLElement {
    connectedCallback() {
      if(this.ready) { this.updateSelection(); return; } this.ready=true;
      this.select=this.querySelector('select'); this.button=this.querySelector('[data-group-add]'); this.status=this.querySelector('[data-group-status]');
      this.select.addEventListener('change',()=>this.updateSelection());
      this.querySelector('form').addEventListener('submit',e=>this.addSelected(e));
      this.updateSelection();
    }
    async updateSelection() {
      const option=this.select.selectedOptions[0]; if(!option) return;
      const selection=this.requestNumber=(this.requestNumber||0)+1;
      this.button.disabled=true; this.button.textContent='Checking availability…'; this.status.textContent='';
      const image=this.querySelector('img'); image.src=option.dataset.image; image.alt=option.dataset.title;
      this.querySelector('[data-group-details]').href=root()+'products/'+encodeURIComponent(option.dataset.handle);
      try {
        const product=await productData(option.dataset.handle);
        if(selection!==this.requestNumber || !this.isConnected) return;
        const variant=product.variants.find(v=>String(v.id)===option.value);
        if(!variant) throw Error('This option is no longer available.');
        this.button.disabled=!variant.available; this.button.textContent=variant.available?'Add to cart':'Sold out';
        this.querySelector('[data-group-price]').textContent=money(variant.price);
        this.status.textContent=variant.available?'':'This option is currently sold out.';
      } catch(e) {
        if(selection!==this.requestNumber || !this.isConnected) return;
        this.button.disabled=true; this.button.textContent='Unavailable'; this.status.textContent='Open product details to check availability.';
      }
    }
    async addSelected(event) {
      event.preventDefault(); if(this.button.disabled) return;
      const option=this.select.selectedOptions[0], quantity=Number(this.querySelector('[name="quantity"]').value);
      if(!Number.isInteger(quantity)||quantity<1||quantity>99) return;
      this.button.disabled=true; this.select.disabled=true; this.status.textContent='Adding to your cart…';
      try {
        const response=await fetch(root()+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(option.value),quantity}]})});
        const result=await response.json(); if(!response.ok) throw Error(result.description||'Unable to add this option.');
        window.location.assign(root()+'cart');
      } catch(e) {
        this.status.textContent=e.message; this.select.disabled=false; this.button.disabled=false; requests.delete(option.dataset.handle);
      }
    }
  }
  function makeCard(item, index) {
    const card=item.card; if(!item.group) return card;
    const group=document.createElement('crate-product-group'); group.className='cg-card';
    const image=document.createElement('img'); image.loading='lazy'; image.width=400; image.height=400; group.append(image);
    const heading=document.createElement('h3'); heading.textContent=item.group.title; group.append(heading);
    const price=document.createElement('p'); price.dataset.groupPrice=''; price.className='cg-price'; price.textContent='Checking price…'; group.append(price);
    const form=document.createElement('form'); form.method='post'; form.action=root()+'cart/add';
    const label=document.createElement('label'); const id='cg-option-'+index+'-'+item.group.key; label.htmlFor=id; label.textContent='Choose an option'; form.append(label);
    const select=document.createElement('select'); select.name='id'; select.id=id;
    for(const p of item.products) for(const v of p.variants) {
      const option=document.createElement('option'); option.value=v.id; option.textContent=v.label; Object.assign(option.dataset,{handle:p.handle,image:p.image,title:p.title}); select.append(option);
    }
    form.append(select);
    const actions=document.createElement('div'); actions.className='cg-actions';
    const quantity=document.createElement('input'); quantity.name='quantity'; quantity.type='number'; quantity.min='1'; quantity.max='99'; quantity.value='1'; quantity.setAttribute('aria-label','Quantity'); actions.append(quantity);
    const button=document.createElement('button'); button.type='submit'; button.dataset.groupAdd=''; button.disabled=true; button.textContent='Checking availability…'; actions.append(button); form.append(actions); group.append(form);
    const details=document.createElement('a'); details.dataset.groupDetails=''; details.textContent='Product details'; group.append(details);
    const status=document.createElement('p'); status.dataset.groupStatus=''; status.setAttribute('role','status'); status.setAttribute('aria-live','polite'); group.append(status);
    card.replaceChildren(group); card.dataset.groupKey=item.group.key; return card;
  }
  class CrateGroupedCollection extends HTMLElement {
    connectedCallback() {
      if(this.ready) return; this.ready=true; this.controller=new AbortController(); this.initialize();
      this.observer=new MutationObserver(()=>{
        const status=this.querySelector('[data-grouping-status]');
        if(!this.loading && status?.textContent==='Loading product options…') {
          this.controller.abort(); this.controller=new AbortController(); this.classList.remove('cg-ready'); this.initialize();
        }
      });
      this.observer.observe(this,{childList:true,subtree:true,characterData:true});
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
    async initialize() {
      this.loading=true;
      const status=this.querySelector('[data-grouping-status]');
      const initial=Array.from(this.querySelectorAll('li[data-product-id]'));
      if(!initial.length) {status.textContent=''; this.loading=false; return;}
      try {
        const url=this.dataset.manifest;
        if(!manifests.has(url)) manifests.set(url,fetch(url).then(r=>{if(!r.ok) throw Error('groups'); return r.json();}).catch(e=>{manifests.delete(url); throw e;}));
        const manifest=await manifests.get(url);
        const pages=Number(this.dataset.pages), current=Number(this.dataset.page); const results=new Map([[current,initial]]);
        const pending=Array.from({length:pages},(_,i)=>i+1).filter(n=>n!==current);
        await Promise.all(Array.from({length:Math.min(3,pending.length)},async()=>{
          while(pending.length) {
            const n=pending.shift(), request=new URL(window.location.href);
            request.searchParams.set('page',String(n)); request.searchParams.set('section_id',this.dataset.section);
            const response=await fetch(request,{signal:this.controller.signal}); if(!response.ok) throw Error('page');
            const doc=new DOMParser().parseFromString(await response.text(),'text/html');
            const wrapper=doc.querySelector('crate-grouped-collection'); if(!wrapper) throw Error('collection');
            results.set(n,Array.from(wrapper.querySelectorAll('li[data-product-id]')));
          }
        }));
        if(!this.isConnected) return;
        const cards=Array.from(results.entries()).sort((a,b)=>a[0]-b[0]).flatMap(entry=>entry[1]);
        this.items=collapse(cards,manifest.groups); this.grid=initial[0].parentElement; this.page=1;
        this.items=this.items.map((item,i)=>makeCard(item,i));
        this.nav=document.createElement('nav'); this.nav.className='cg-pagination'; this.nav.setAttribute('aria-label','Product pages');
        this.previous=document.createElement('button'); this.previous.textContent='Previous'; this.previous.type='button'; this.previous.addEventListener('click',()=>this.showPage(this.page-1,true));
        this.counter=document.createElement('span'); this.counter.setAttribute('aria-live','polite');
        this.next=document.createElement('button'); this.next.textContent='Next'; this.next.type='button'; this.next.addEventListener('click',()=>this.showPage(this.page+1,true));
        this.nav.append(this.previous,this.counter,this.next); this.grid.parentElement.append(this.nav); this.grid.parentElement.prepend(status);
        this.classList.add('cg-ready'); status.textContent=this.items.length+' products · choose colors, sizes, and styles within each listing'; this.showPage(1,false);
      } catch(e) {
        if(this.isConnected) status.textContent='Browse products below. Grouped options are temporarily unavailable.';
      } finally { this.loading=false; }
    }
    showPage(page,scroll) {
      const total=Math.max(1,Math.ceil(this.items.length/24)); this.page=Math.max(1,Math.min(page,total));
      this.grid.replaceChildren(...this.items.slice((this.page-1)*24,this.page*24));
      this.previous.disabled=this.page===1; this.next.disabled=this.page===total; this.counter.textContent='Page '+this.page+' of '+total;
      this.nav.hidden=total===1;
      if(scroll) this.grid.scrollIntoView({behavior:'smooth',block:'start'});
    }
  }
  if(!customElements.get('crate-product-group')) customElements.define('crate-product-group',CrateProductGroup);
  if(!customElements.get('crate-grouped-collection')) customElements.define('crate-grouped-collection',CrateGroupedCollection);
})();